import { currentUser } from './stores';
import { get } from 'svelte/store';

const sb_auth_url = () => {
    return [true, 'true'].includes(process['env'].PROD_ENV) ? 'https://auth.shopbox.ai' : 'https://beta-sb-auth-vlwut6qbsq-lz.a.run.app';
}

export const createTicket = async (subject, description, type) => {
    await fetch(sb_auth_url() + `/api/v1/tickets?cid=${get(currentUser).clientId}`,
        {
            body: JSON.stringify({
                subject: subject,
                description: description,
                type: type
            }),
            headers: {
                Authorization: `Bearer ${get(currentUser).accessToken}`,
                'Content-Type': 'application/json'
            },
            method: 'POST'
        });
};